/**
 * @author: Wangwei
 * @description: 打卡营首页
 */
import { useModel } from 'umi';
import CmpUnderwayCard from './components/campUnderwayCard';
import CampIndexTabs from './components/campIndexTbas';
import EventTracking from '@/pages/camp/components/tracking/EventTracking';

export default function campIndex() {
  const { initialState } = useModel('@@initialState');
  return (
    <div className="w1200 ptb24">
      {/* 正在打卡 */}
      {initialState?.uid && <CmpUnderwayCard />}

      {/* 全部打卡营 */}
      <CampIndexTabs />
      <EventTracking />
    </div>
  );
}
